import React,{ useEffect, useState } from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import { MatchParams } from '../types';
import useSubscribers from '../../hooks/useSubscribers';
import PaymentHistoryItems from '../../components/PaymentHistoryItems/PaymentHistoryItems';
import useLists from '../../hooks/useLists';
import PageNav from '../../components/PageNav/PageNav';



function PaymentHistory (props:RouteComponentProps<MatchParams>) {
  const { listId, email } = props.match.params
  const { goBack } = props.history
  const { subscribersInfo, getSubscribersInfoData, getNextPaidLogs } = useSubscribers()
  const { listsInfo, getListsInfoData } = useLists()
  const [ offset, setOffset ] = useState(0)

  useEffect(()=>{
    getListsInfoData(listId)
    getSubscribersInfoData({listId:listId,subscriber:email})
  },[])

  const nextPage = () =>{
    getNextPaidLogs({listId:listId,subscriber:email,query:`limit=10&offset=${offset+10}`})
    setOffset(offset+10)
  }

  const prevPage = () =>{
    getNextPaidLogs({listId:listId,subscriber:email,query:`limit=10&offset=${offset-10}`})
    setOffset(offset-10)
  }

  return(
    <>
    <div className="form-frame-subscriber">
      <div className="inner">
        <div id="stb_subscriber">
        <button className='btn back' onClick={()=>goBack()}/>
          <div className="stb_subscriber_header">
            <h1>결제 내역</h1>
          </div>
          <div className="stb_subscriber_history_name">
            {listsInfo.data.listName}<br/>
            {subscribersInfo.data.email}
          </div>
          {!subscribersInfo.data.paidLogs 
          || subscribersInfo.data.paidLogs.length === 0
          ?
            <div className="stb_subscriber_history_item empty">
              결제 내역이 없습니다.
            </div>
            :
            <>
              {subscribersInfo.loading?
                //replace tospinner
                ''
                :
                subscribersInfo.data.paidLogs.map((v)=><PaymentHistoryItems key={v.startDate} {...v}/>)
              }

              <PageNav total={subscribersInfo.data.paidTotalCount} limit={10} offset={offset} nextPage={nextPage} prevPage={prevPage}/>
            </>
          }
        </div>
      </div>
    </div>
    </>
  )
}

export default withRouter(PaymentHistory);